import React from "react";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const TotalvsAngagementGraph = ({ videoAnalytics }) => {
  return (
    <div className="engagement-attension-card h-100">
      <h5>
        Total vs Engaged Time
      </h5>

      <div className="d-flex align-items-center justify-content-between mt-0">
        <div className="col-lg-6">
          <div className="">
            <p>Engaged Time </p>
            <h4>
              {videoAnalytics?.engagedTime ? (
                <>
                  {videoAnalytics?.engagedTime < 3600 ? (
                    <>
                      <span className="time-bold">
                        {`${parseInt(
                          videoAnalytics?.engagedTime / 60
                        )}`.padStart(2, 0)}
                      </span>
                      <span> Min. </span>
                      <span className="time-bold">
                        {`${videoAnalytics?.engagedTime % 60}`.padStart(2, 0)}
                      </span>
                      <span> Sec. </span>
                    </>
                  ) : (
                    <>
                      <span className="time-bold">
                        {`${parseInt(
                          videoAnalytics?.engagedTime / 3600
                        )}`.padStart(2, 0)}
                      </span>
                      <span> Hr. </span>
                      <span className="time-bold">
                        {`${(videoAnalytics?.engagedTime / 3600) % 1}`.padStart(
                          2,
                          0
                        )}
                      </span>
                      <span> Min. </span>
                    </>
                  )}
                </>
              ) : (
                0
              )}
            </h4>
          </div>
          <div
            style={{ borderBottom: "1px solid #CACACE", marginTop: ".7rem" }}
          ></div>
          <div>
            <p>Total Watch Time</p>

            <h4>
              {videoAnalytics?.totalTime ? (
                <>
                  {videoAnalytics?.totalTime < 3600 ? (
                    <>
                      <span className="time-bold">
                        {`${parseInt(videoAnalytics?.totalTime / 60)}`.padStart(
                          2,
                          0
                        )}
                      </span>
                      <span> Min. </span>
                      <span className="time-bold">
                        {`${videoAnalytics?.totalTime % 60}`.padStart(2, 0)}
                      </span>
                      <span> Sec. </span>
                    </>
                  ) : (
                    <>
                      <span className="time-bold">
                        {`${parseInt(
                          videoAnalytics?.totalTime / 3600
                        )}`.padStart(2, 0)}
                      </span>
                      <span> Hr. </span>
                      <span className="time-bold">
                        {`${(videoAnalytics?.totalTime / 3600) % 1}`.padStart(
                          2,
                          0
                        )}
                      </span>
                      <span> Min. </span>
                    </>
                  )}
                </>
              ) : (
                0
              )}
            </h4>
          </div>
        </div>
        <div className="col-lg-6 d-flex justify-content-end align-items-center">
          <div style={{ width: "170px", height: "170px" }}>
            <CircularProgressbar
              value={videoAnalytics ? videoAnalytics?.viewerEngagement : 0}
              text={
                videoAnalytics?.viewerEngagement
                  ? videoAnalytics?.viewerEngagement + "%"
                  : 0
              }
              strokeWidth={12}
              styles={{
                path: {
                  strokeLinecap: "butt",
                  transform: "rotate(0turn)",
                  transformOrigin: "center center",
                  stroke: "#1974CE",
                },
                text: {
                  fill: "#313135",
                  fontSize: "16px",
                  fontWeight: 600,
                },
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TotalvsAngagementGraph;
